import React, { useCallback, useEffect } from 'react';
// Utils
import { getSessionStorageItem, useSetState } from 'utils';
import { enableLogout, setAuthError, setLoading } from 'utils/login';
// Context
import { useAuthDispatch, useAuthState } from 'context/AuthContext';
import { authoriseEmployeeReturn, initialiseGoogleLogin } from 'context/AuthContext/middleware';
import { GOOGLE_LOGOUT, UNAUTHORISE_EMPLOYEE } from 'context/AuthContext/statusFlags';
// Assets
import { Logo } from 'assets/Logos';
import GoogleSignInNew from './login';
// Elements
import Alert from 'elements/Alert';
import Button from 'elements/Button';
import { Loading } from 'elements/Loading';
// Style
import styles from './style/login.module.css';

function Login() {
  const dispatch = useAuthDispatch();
  const { authState } = useAuthState();
  const initialState = {
    errorMessage: '',
    loading: true,
  }
  const [state, setState] = useSetState(initialState);
  const loggingOut = (authState === UNAUTHORISE_EMPLOYEE || authState === GOOGLE_LOGOUT)
  
  const handleLoginSession = useCallback(async () => {
    const employee = getSessionStorageItem({ item: 'employee' });
    const user = getSessionStorageItem({ item: 'user' });
    if (employee && user) {
      await authoriseEmployeeReturn(dispatch);
    } 
    // else {
    //   await initialiseGoogleLogin(dispatch)
    // }
  }, [dispatch]);

  useEffect(() => {
    setState({
      errorMessage: setAuthError(authState),
      loading: setLoading(authState),
    });
  }, [authState, setState]);

  useEffect(() => {
    if (!loggingOut) {
      handleLoginSession();
    }
  }, [handleLoginSession, loggingOut]);

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.content}>
          <Logo />
          <h1 className="display5">Sales Order App</h1>
          <div>
            { state.loading || loggingOut ? (
              <Button btnStyle="secondary" btnType="icon" label="loading">
                <Loading fill="white" size={32} />
              </Button>
            ) : (
              <>
                { enableLogout(authState) ? (
                  <Button handler={() => null} btnStyle="secondary">Logout</Button>
                ) : (
                  // <div id="my-signin2" className="googleBtn" />
                  <GoogleSignInNew/>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <footer className={styles.footer}>
        <Alert
          active={state.errorMessage}
          label={state.errorMessage}
          type="error"
        />
        <p className="body2">Version 5.2</p>
      </footer>
      { loggingOut && (
        <img
          alt=""
          src="https://www.google.com/accounts/Logout"
        />
      )}
    </div>
  );
}

export default Login;
